import React from 'react';
import { Button } from './ui/button';

const Header = ({ companyInfo, onContactClick }) => {
  if (!companyInfo) return null;

  return (
    <header className="dark-header">
      <div className="flex items-center">
        <div className="flex items-center gap-3">
          <img 
            src="https://customer-assets.emergentagent.com/job_sea-forward/artifacts/vucx67ga_ChatGPT%20Image%20Oct%2011%2C%202025%2C%2011_49_30%20AM.png" 
            alt="AquaSage Advisory Logo" 
            className="w-10 h-10 object-contain"
          />
          <span className="font-semibold text-xl" style={{color: 'var(--text-primary)'}}>{companyInfo.name}</span>
        </div>
      </div>
      
      <nav className="dark-nav hidden md:flex">
        <a href="#services" className="dark-nav-link">Services</a>
        <a href="#about" className="dark-nav-link">About</a>
        <a href="#contact" className="dark-nav-link">Contact</a>
      </nav>
      
      <Button 
        onClick={onContactClick}
        className="btn-primary hidden md:inline-flex"
      >
        Get Consultation
      </Button>
    </header>
  );
};

export default Header;